import React, { useCallback } from "react";
import { HtmlEditor } from "./HtmlEditor";
import { htmlToMarkdown, markdown2html } from "../message-board/htmlToMarkdown";

/**
 * MarkdownEditor uses HtmlEditor for input but converts output to markdown
 * @param {object} props
 * @param {string} props.initialValue the value from the server - this is markdown
 * @param {(text: string) => void} props.onChange
 * @param {import("@seabrookstudios/pitch2table-core").EditorImplementations} [props.source]
 */
export const MarkdownEditor = ({ initialValue = "", onChange, source = "Markdown" }) => {
  const initialHtmlValue = source === "Markdown" ? markdown2html(initialValue) : initialValue;

  const handleHtmlChange = useCallback(
    (newHtmlValue) => {
      try {
        onChange(htmlToMarkdown(newHtmlValue));
      } catch (error) {
        console.warn("Error converting HTML to markdown:", error);
        onChange(newHtmlValue);
      }
    },
    [onChange]
  );

  return (
    <HtmlEditor
      initialValue={initialHtmlValue}
      onChange={handleHtmlChange}
      enableMarkdownPaste={source === "Markdown"}
    />
  );
};
